import { TextBox } from '@apply/components';
import { useBorrowerEsignTitle } from '../../../../../queries/BorrowerFields/EsignFields';

export const Title: React.FC = () => {
    const [title, set_Title] = useBorrowerEsignTitle();
    return (
        <TextBox
            value={title ?? ''}
            onChange={(value) => set_Title(value)}
            label='Title'
            required={true}
        />
    );
};
